module.exports = __webpack_public_path__ + "static/fonts/fontello.ff47dfb.eot";


//////////////////
// WEBPACK FOOTER
// ./~/vue-goodshare/src/fonts/fontello.eot?88483298
// module id = 400
// module chunks = 14 15